import { createSelector } from '@reduxjs/toolkit';
import { getInfrastructureMicrofrontendRequestParams } from 'shared/utils/infrastructure/getInfrastructureMicrofrontendRequestParams';

import { selectOfferId } from '../offerData/offer/selectOfferId';
import { pageDataSelector } from '../pageData/root/pageDataSelector';

export const selectInfrastructureMicrofrontendRequestParams = createSelector(
  [pageDataSelector, selectOfferId],
  (pageData, offerId) => getInfrastructureMicrofrontendRequestParams(pageData, offerId),
);
